export default { PACKAGE_VERSION: "1.4.0" };
